import type { IToolbarItemConfigTiptap } from './../../ricos-types';
import { resolversById } from './../../toolbars-v3';
import { RESOLVERS_IDS } from './../../toolbars-v3/lib/resolvers-ids';

export default (id: $TSFixMe, component: $TSFixMe): IToolbarItemConfigTiptap => {
  return {
    id,
    type: 'custom',
    attributes: {
      visible: resolversById[RESOLVERS_IDS.ALWAYS_VISIBLE],
    },
    commands: {},
    presentation: {
      component,
      dataHook: 'customButton',
    },
  };
};
